import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { Metamodel } from 'app/model/base/model';
import { ConnectionAuthKind, format } from 'shell-models-lib';
import { ControlMetadata } from 'app/extensibility/metadatas/control/control-metadata';
import { FabricLinkedService, fabricAuthTypes } from 'app/model/linkedservice/fabric-workspace.linkedservice';
import { azureResourceSelectMethodOptions } from 'app/registries/consts/metadata-consts';

const workspaceSelectionSetting: ControlMetadata = {
    type: 'radio-switch',
    nested: 1,
    label: stringResources.Fabric_Workspace_SelectionMethod,
    description: stringResources.Fabric_Workspace_SelectMethodDescription,
    options: azureResourceSelectMethodOptions,
    defaultValue: '{workspaceId != null ? "manual" : "azure"}',
    isLabelVertical: true,
    cases: [
        {
            caseValue: 'azure',
            children: [
                {
                    type: 'fabric-workspace-select',
                    bind: {
                        workspaceId: 'workspaceId'
                    },
                    validators: {
                        workspaceId: [
                            { type: 'required', errorMessage: '' }
                        ]
                    }
                }
            ]
        },
        {
            caseValue: 'manual',
            children: [
                {
                    type: 'parameterizable',
                    child: {
                        type: 'textbox',
                        bind: 'workspaceId',
                        label: stringResources.FabricWorkspaceId,
                        required: true,
                        validators: [
                            { type: 'required', errorMessage: '' }
                        ],
                        isLabelVertical: true
                    }
                }
            ]
        }
    ]
};

const tenantTextBoxSetting: ControlMetadata = {
    type: 'parameterizable',
    child: {
        type: 'tenant-textbox',
        bind: 'tenant',
        validators: [
            { type: 'required', errorMessage: '' }
        ],
        isLabelVertical: true,
        label: stringResources.ModelName_Tenant,
        required: true
    }
};

const servicePrincipalIDSetting: ControlMetadata = {
    type: 'parameterizable',
    child: {
        type: 'textbox',
        bind: 'servicePrincipalId',
        label: stringResources.ModelName_ServicePrincipalID,
        required: true,
        validators: [
            { type: 'required', errorMessage: '' }
        ],
        isLabelVertical: true
    }
};

const servicePrincipalKeySetting: ControlMetadata = {
    type: 'dynamic-akv-switcher',
    enableAKVParameterization: true,
    bind: 'servicePrincipalKey',
    label: stringResources.ModelName_ServicePrincipalKey,
    child: {
        type: 'parameterizable',
        attribute: 'servicePrincipalKey',
        child:
        {
            type: 'password',
            label: stringResources.ModelName_ServicePrincipalKey,
            required: true,
            isLabelVertical: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ]
        }
    },
    description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Fabric_Workspace_Label),
        stringResources.ModelName_ServicePrincipalKey)
};

export const fabricMetadata: ILinkedServiceTypeMetadata = {
    type: Metamodel.modelFor(FabricLinkedService).name,
    displayName: stringResources.Fabric_Workspace_Label,
    supportedInTrident: true,
    icon: {
        className: 'svg-i-20x20-adf'
    },
    category: ['Azure'],
    supportedAuthKindsInTrident: [ConnectionAuthKind.OAuth2, ConnectionAuthKind.ServicePrincipal] as ConnectionAuthKind[],
    isCompute: true,
    isFirstClass: true,
    copySinkTypes: [],
    copySourceTypes: [],
    disableQueryAPI: true,
    supportFirstClassParameterExperience: true,
    controls: [
        workspaceSelectionSetting,
        {
            type: 'select-switch',
            bind: 'authenticationType',
            label: stringResources.Authentication_Method_Label,
            options: [
                {
                    label: stringResources.AuthenticationType_ManagedServiceIdentity,
                    value: fabricAuthTypes.MSIAuthentication
                },
                {
                    label: stringResources.AuthenticationType_ServicePrincipal,
                    value: fabricAuthTypes.ServicePrincipalAuthentication
                }
            ],
            isLabelVertical: true,
            defaultValue: fabricAuthTypes.MSIAuthentication,
            cases: [
                {
                    caseValue: fabricAuthTypes.MSIAuthentication,
                    children: [
                        {
                            type: 'management-identity-info',
                            resourceType: stringResources.AzureDataFactory,
                            link: 'https://go.microsoft.com/fwlink/?linkid=2164350'
                        }
                    ]
                },
                {
                    caseValue: fabricAuthTypes.ServicePrincipalAuthentication,
                    children: [
                        tenantTextBoxSetting,
                        servicePrincipalIDSetting,
                        servicePrincipalKeySetting
                    ]
                }
            ]
        }
    ]
};
